export interface Settings {
  soundEnabled: boolean
}

export function defaultSettings(): Settings {
  return {
    soundEnabled: true,
  }
}
